import { combineReducers } from 'redux';
import authorHighlights, {
  State as AuthorHighlightsState,
  initialState as initialAuthorHighlights,
} from './AuthorHighlights';
import reviewerHighlights, {
  State as ReviewerHighlightsState,
  initialState as initialReviewerHighlights,
} from './ReviewerHighlights';

export default combineReducers<State>({
  authorHighlights,
  reviewerHighlights,
});

export interface State {
  authorHighlights: AuthorHighlightsState;
  reviewerHighlights: ReviewerHighlightsState;
}

export const initialState: State = {
  authorHighlights: initialAuthorHighlights,
  reviewerHighlights: initialReviewerHighlights,
};
